module.exports = __webpack_public_path__ + "img/youtube.5729e428.png";